export type ModalStep =
  | 'confirmId'
  | 'confirmOab'
  | 'validating'
  | 'validatingError'
  | 'validatingSuccess'
  | 'emailSent'
  | 'oabTransferring'
  | 'oabTransferringSuccess'
  | 'oabTransferringError'

type StepTransitions = Record<ModalStep, { success: ModalStep; error?: ModalStep }>

export const stepTransitions: Partial<StepTransitions> = {
  confirmId: {
    success: 'confirmOab',
  },
  confirmOab: {
    success: 'validating',
  },
  validating: {
    success: 'validatingSuccess',
    error: 'validatingError',
  },
  validatingError: {
    success: 'emailSent',
  },
  oabTransferring: {
    success: 'oabTransferringSuccess',
    error: 'oabTransferringError',
  },
  oabTransferringError: {
    success: 'validatingError',
  },
}
